import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { ICategoryContext, CategoryContext } from '../../../categoryState/categoryContext';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';

export const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString, IDSelectedRestaurant, IDsSelectedCategoryTypes } =
		useContext<ICategoryContext>(CategoryContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: searchString || IDSelectedRestaurant || IDsSelectedCategoryTypes.length,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};
